import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Modal, Select, Table } from 'antd'
import axios from 'axios'
import { Card, Col, Container, Row } from 'react-bootstrap'
import { AUTH_URL } from '../constants'
import { CloseOutlined, EditFilled, SaveOutlined, UserAddOutlined } from '@ant-design/icons'
import { notify, notify_success, toastStyle } from '../pages/LoginPage'
import { TfiReload } from 'react-icons/tfi'
import { IoMdArrowDropright } from 'react-icons/io'

//Interfaces
export interface IUser {
        _id: string | undefined,
        surname: string | undefined,
        other_names: string | undefined,
        phone: string | number | undefined,
        email: string | number | undefined,
        branch: string[]| undefined,
        role: string | number | undefined,
        active?: boolean
    }

export interface IBranch  {
  name: string,
  _id: string
}

const UsersTable
 = () => {

    //variable/states
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userLoaded, setUserLoaded] = useState(false);
    const [newUserSurname, setnewUserSurname]= useState<string | undefined>()
    const [newUserOthername, setnewUserOthername]= useState<string | undefined>()
    const [newUserEmail, setnewUserEmail]= useState<string | undefined>()
    const [newUserPhone, setnewUserPhone]= useState<string | undefined>()
    const [newUserPassword, setnewUserPassword]= useState<string | undefined>()
    const [newUserPasswordConfirm, setnewUserPasswordConfirm]= useState<string | undefined>()
    const [showNewUserForm, setShowNewUserForm]= useState<boolean>(false)
    const [confirmLoading, setConfirmLoading]= useState<boolean>(false)
    const [branches, setBranches]= useState<IBranch[]>()
    const [selectedBranch, setSelectedBranch] = useState<string>();
    const [reloadComponent, setReloadComponent] = useState(false);
    const [editMode, setEditMode]= useState<boolean>(false)
    const [userData, setUserData] = useState<IUser | null>({
      _id: undefined,
      surname: undefined,
      other_names: undefined,
      phone: undefined,
      email: undefined,
      branch: undefined,
      role: undefined
    });
    const [userSurname, setUserSurname]= useState<string | undefined>()
    const [userOthername, setUserOthername]= useState<string | undefined>()
    const [userEmail, setUserEmail]= useState<string | undefined>()
    const [userPhone, setUserPhone]= useState<string | undefined>()
    const [userPlant, setUserPlant]= useState<string | undefined>()
    const [selectedUser, setSelectedUser]= useState<IUser>()
    const [usersLoaded, setUsersLoaded] = useState(false);
    const [usersData, setUsersData] = useState();
    const [loadingClientUsers, setLoadingClientUsers] = useState(false)
    const [addingUser, setAddingUser] = useState(false)
    const [editingUser, setEditingUser] = useState(false)

    const [form] = Form.useForm()
    
//Get Client users
    const getClientUsers = async()=>{
        try {

            setLoadingClientUsers(true)
            const users_request_response = await axios.get(`${AUTH_URL}/users/`)
            setLoadingClientUsers(false)
            if(users_request_response.data.success){
                setUsersLoaded(true)
                setUsersData(users_request_response.data.users)
              
            }else{
                setUsersLoaded(false)

             
                notify(users_request_response.data.message, toastStyle,)

            }

        } catch (error: any) {  
             notify(error.message, toastStyle,)
           
        }
    }

    const clearUserData = ()=> setUserData(null)

    //Components


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false)
    clearUserData()
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    clearUserData()
  };

  const clearFields = ()=>{
    setnewUserSurname('')
    setnewUserEmail('')
    setnewUserOthername('')
    setnewUserPhone('')
    setnewUserPassword('')
    setnewUserPasswordConfirm('')
  }

  const handleRowClick = async (record: any) => {
       setSelectedUser(record._id)
        const user_data = await axios.get(`${AUTH_URL}/users/${record._id}`)
        if(user_data.data.success){
            setUserData(user_data.data.user)
            setUserLoaded(true)
            showModal()
        }
  }

  const columns = [
  {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Surname',
    dataIndex: 'surname',
    key: 'surname',
  },
    {
    title: 'Given name',
    dataIndex: 'other_names',
    key: 'other_names',
  },
  {
    title: 'Phone Number',
    dataIndex: 'phone',
    key: 'phone',
  },
   {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
   {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Action',
    dataIndex: '',
    key: '_id',
    render: (text: string, record: any) => <Button type='link' onClick={()=>handleRowClick(record)}>View</Button>,
  },


];

  const handleCancelUserForm = ()=>{
    setShowNewUserForm(false)
  }

  const getBranchNames = async()=> {
    
  const response = await axios.get(`${AUTH_URL}/branch-names`)
  if(response.data.success){
      setBranches(response.data.branches)
  }else{
    notify('There are no branches in the database', toastStyle)
  }
  } 

  const handleAddUser = async ()=>{
    setAddingUser(true)
    const response = await axios.post(`${AUTH_URL}/users/signup`, {surname: newUserSurname, other_names: newUserOthername, email: newUserEmail, phone: newUserPhone, branch: selectedBranch, password: newUserPassword, passwordConfirm: newUserPasswordConfirm }, {withCredentials: true})
    setAddingUser(false)
    if(response.data.success){
      notify_success(`${response.data.message}`, toastStyle)
      clearFields()
      form.resetFields()
      setReloadComponent(true)

    }else{
      notify(`${response.data.message}`, toastStyle)
    }
  }

  const handleEditUser = async()=>{
      const response = await axios.patch(`${AUTH_URL}/users/${userData?._id}`, userData, {withCredentials: true})
      if(response.data.success){
        notify_success('User details updated successfully', toastStyle)
        setReloadComponent(true)
        setIsModalOpen(false)
      }else{
        notify(`User cannot be update now! Contact admin`, toastStyle)
        handleCancel()
      }
  }
  
useEffect(()=>{
    if(reloadComponent){
        getClientUsers()
        setReloadComponent(false)
    }
}, [reloadComponent])

  useEffect(()=>{
    getBranchNames()
    getClientUsers()
  },[])

  return (
    <Container fluid>
     <Row>
       <Col>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Users</h4>
      
       </Col>
       <Col className='d-flex justify-content-end'>
       <Button onClick={()=> setShowNewUserForm(true)} className='text-uppercase small text-end rounded-0'> <UserAddOutlined />{confirmLoading ? 'Adding User' : 'Add User' }</Button>

       </Col>
      </Row>
      <Row className='my-2'>
          <Table style={{borderRadius: 0}} bordered dataSource={usersData} columns={columns}/>
      
      </Row>

        {(userData && userLoaded) && 
         <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
         centered
         footer={[
                    editMode 
                    ? [
                        <Button loading={editingUser} type='primary' className='rounded-0 text-uppercase' key="edit_user" onClick={handleEditUser}>
                           <span><SaveOutlined /></span>
                           
                           {
                            editingUser?

                           'Saving... Changes'
                           :
                           'Save Changes'
                           
                           }
                         </Button>,
                         <Button className='rounded-0 text-uppercase' key="edit_mode_off" onClick={(e)=>setEditMode(false)}>
                           <span><CloseOutlined /> </span>Cancel Editing
                         </Button>,

                     ]
                    : 
                      [

                      <Button type='primary' className='rounded-0 text-uppercase' key="edit_mode_on" onClick={(e)=>setEditMode(true)}>
                        <span><EditFilled /></span>Edit User
                      </Button>,
                      <Button  className='rounded-0 text-uppercase' key="cancel" onClick={handleCancel}>
                      <CloseOutlined />   Cancel
                      </Button>

                      ]
                ]}
         >
         <Row>
         <Col>
         <p className='text-uppercase fw-bold' style={{fontSize: '18px'}}>User Details</p>
         </Col>
         </Row>
         <Card className='p-2 rounded-0'>
                <Form
                layout="vertical"
                    >
                    <Form.Item 
                    label="Surname" 
                    rules={[{required: true, message: "Surname is required!"}]}
                    name="surname"
                    initialValue={userData.surname}
                    >
                        <Input disabled={!editMode} value={userSurname} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    surname: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    <Form.Item label="Other names"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="other_names"
                    initialValue={userData.other_names}
                    >
                        <Input disabled={!editMode} value={userOthername} 
                        onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    other_names: e.target.value,
                                }))
                            }  
                        />
                    </Form.Item>
                    <Form.Item 
                    label="Email"
                    rules={[{required: true, message: "Email is required!"}]}
                    name="email"
                    initialValue={userData.email}

                    >
                        <Input disabled={!editMode} value={userEmail} 
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    email: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                    <Form.Item 
                      label="Phone"
                      rules={[{required: true, message: "Phone number is required!"}]}
                      name="phone"
                      initialValue={userData.phone}

                      >
                        <Input disabled={!editMode}
                          onChange={(e) =>
                                setUserData((prevUserData: any) => ({
                                    ...prevUserData,
                                    phone: e.target.value,
                                }))
                            }
                         />
                    </Form.Item>
                   <Form.Item
                      label="Select branch"
                      name="branch"
                      rules={[{ required: true, message: "User must belong to a branch!" }]}
                      initialValue={userData.branch ? userData.branch : undefined}
                    >
                      <Select
                        allowClear
                        placeholder="Select branch name"
                        value={userPlant}
                        style={{ width: '100%' }}
                        disabled={!editMode}
                      />
                    </Form.Item>

                </Form>
            </Card>
      </Modal>
        }
             <Row>
        {showNewUserForm && 
         <Modal
                title={`Add New User`}
                open={showNewUserForm}
                onOk={handleAddUser}
                confirmLoading={confirmLoading}
                onCancel={handleCancelUserForm}
                centered={true}
                footer={[
                    
                ]}
            >
            <Row>
            <Card className='py-3 rounded-0'>
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={handleAddUser}
                    >
                    <Form.Item 
                    label="Surname" 
                    rules={[{required: true, message: "Surname is required!"}]}
                    name="surname"
                    >
                        <Input value={newUserSurname} onChange={(e)=> setnewUserSurname(e.target.value)} />
                    </Form.Item>
                    <Form.Item label="Other names"
                    rules={[{required: true, message: "Other name is required!"}]}
                    name="other_names"
                    >
                        <Input value={newUserOthername} onChange={(e)=>setnewUserOthername(e.target.value)}  />
                    </Form.Item>
                    <Form.Item 
                    label="Email"
                    rules={[{required: true, message: "Email is required!"}]}
                    name="email"
                    >
                        <Input value={newUserEmail} onChange={(e)=>setnewUserEmail(e.target.value)} />
                    </Form.Item>
                    <Form.Item 
                      label="Phone"
                      rules={[{required: true, message: "Phone number is required!"}]}
                      name="phone"
                      >
                        <Input value={newUserPhone} onChange={(e)=>setnewUserPhone(e.target.value)} />
                    </Form.Item>
                    <Form.Item
                      label="Select Branch"
                      name="plant"
                      rules={[{required: true, message: "User must belong to a branch!"}]}

                    >

                    <Select
                        allowClear
                        placeholder="Select branch name"
                        value={selectedBranch}
                        onChange={setSelectedBranch}
                        style={{ width: '100%' }}
                        options={branches?.map((branch) => ({
                          value: branch._id,
                          label: branch.name,
                        }))}
                      />
                    
                    </Form.Item>
                    <Row>
                    <Col className='d-flex'>
                    <Button type='primary' className='rounded-0 text-uppercase' key="edit" htmlType='submit'>
                       <span><UserAddOutlined /></span>
                       
                       {
                       addingUser ?
                       'Adding User...'
                       :
                       'Add User'
                       
                       }
                    </Button>
                    <Button className='rounded-0 text-uppercase mx-2' key="cancel" onClick={handleCancelUserForm}>
                     <CloseOutlined />   Cancel
                    </Button>
                    
                    </Col>
                    
                    </Row>
                </Form>
            </Card>
                

            
            </Row>
            </Modal>
        
        }
           
        </Row>
     
    </Container>
    
  )
}

export default UsersTable

